import type WebSocket from 'ws';
import { parseApiToBridgeMessage } from '../types/api-to-bridge-messages.js';
import type { MessageHandlerDeps } from './message-handler-deps.js';
import { dispatchBridgeMessage } from './dispatch-bridge-message.js';

export type { MessageHandlerDeps as BridgeMessageDeps };

/** Compact server→CLI heartbeat ack (`t:'ha', s`) → shape expected by {@link parseApiToBridgeMessage}. */
function normalizeInboundBridgeWebSocketJson(data: unknown): unknown {
  if (data === null || typeof data !== 'object' || Array.isArray(data)) return data;
  const o = data as Record<string, unknown>;
  if (o.t === 'ha' && typeof o.s === 'number' && Number.isFinite(o.s)) {
    return { type: 'ha', s: Math.trunc(o.s) };
  }
  return data;
}

/**
 * Route an incoming bridge WebSocket message to the appropriate handler.
 * {@link createWsBridge} already defers off the native `message` callback; parse + dispatch here
 * run on that next tick so JSON validation and handlers do not extend the WebSocket receive path.
 */
export function handleBridgeMessage(
  data: unknown,
  deps: MessageHandlerDeps,
  sourceWs?: WebSocket | null,
): void {
  const active = deps.getWs();
  if (!active) return;
  if (sourceWs != null && sourceWs !== active) return;
  const msg = parseApiToBridgeMessage(normalizeInboundBridgeWebSocketJson(data), deps.log);
  if (!msg) return;
  dispatchBridgeMessage(msg, deps);
}
